exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Opacity___0___1B3Hw {\n  opacity: 0; }\n\n.Opacity___01___3Ye1g {\n  opacity: 0.1; }\n\n.Opacity___02___5YGEt {\n  opacity: 0.2; }\n\n.Opacity___03___1bRbW {\n  opacity: 0.3; }\n\n.Opacity___04___CwEax {\n  opacity: 0.4; }\n\n.Opacity___05___2c6Zx {\n  opacity: 0.5; }\n\n.Opacity___06___sv5VR {\n  opacity: 0.6; }\n\n.Opacity___07___1nZ7V {\n  opacity: 0.7; }\n\n.Opacity___08___3jMCr {\n  opacity: 0.8; }\n\n.Opacity___09___1EZGZ {\n  opacity: 0.9; }\n\n.Opacity___1___3dpMr {\n  opacity: 1; }\n", ""]);

// exports
exports.locals = {
	"_0": "Opacity___0___1B3Hw",
	"_01": "Opacity___01___3Ye1g",
	"_02": "Opacity___02___5YGEt",
	"_03": "Opacity___03___1bRbW",
	"_04": "Opacity___04___CwEax",
	"_05": "Opacity___05___2c6Zx",
	"_06": "Opacity___06___sv5VR",
	"_07": "Opacity___07___1nZ7V",
	"_08": "Opacity___08___3jMCr",
	"_09": "Opacity___09___1EZGZ",
	"_1": "Opacity___1___3dpMr"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js!./src/styles/Opacity.scss
// module id = 168
// module chunks = 0